import { useRef } from 'react';
var counter = 0;
export function generateUniqueId(prefix) {
    return "" + (prefix ? prefix : '') + counter++ + "-" + Date.now() + "-" + Math.round(Math.random() * 10000);
}
export function useUniqueId(prefix) {
    var uniqueId = useRef(generateUniqueId(prefix)).current;
    return uniqueId;
}
//# sourceMappingURL=index.js.map